import BasePolicy from '@/policies/BasePolicy.js';

export default class UserGroupPolicy extends BasePolicy {
    viewAny(user) {
        const permission = 'view all user groups';

        return user.hasPermissionTo(permission) || user.hasGroupPermissionTo(permission);
    }

    viewAnyOnUserPage(user, person) {
        return (
            user.id === person.id ||
            user.hasPermissionTo('view groups on profile page') ||
            user.hasGroupPermissionTo('view groups on profile page')
        );
    }

    view(user, userGroup) {
        const permission = 'view a user group';

        return (
            userGroup.user_id === user.id || user.hasPermissionTo(permission) || user.hasGroupPermissionTo(permission)
        );
    }

    create(user) {
        const permission = 'create a user group';

        return user.hasPermissionTo(permission) || user.hasGroupPermissionTo(permission);
    }

    update(user, userGroup) {
        const permission = 'edit a user group';

        return user.hasPermissionTo(permission) || user.hasGroupPermissionTo(permission);
    }

    delete(user, userGroup) {
        const permission = 'delete a user group';

        return user.hasPermissionTo(permission) || user.hasGroupPermissionTo(permission);
    }
}
